import type { User } from "@repo/shared-types";
import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";

export const accessTokenAtom = atomWithStorage<string | null>(
  "accessToken",
  null,
  undefined,
  {
    getOnInit: true,
  }
);

export const userAtom = atom<User | null>(null);
